import React, { useContext } from 'react';
import Card from 'antd/lib/card';
import { StepsValidationStatusContext } from '../context/StepsValidationStatusProvider';
import ls from './ProgressBar.less';
import {env} from '../env';
import { ModelContext } from './metadata/ModelSource';
import Popover from 'antd/lib/popover';
import Badge from 'antd/lib/badge';
import {DriversAndVehiclesDataReportContext} from '../context/DriversAndVehiclesDataReportProvider';
import { WorkflowStepsContext } from '../context/WorkflowStepsProvider';

import ProgressBarIcon from './ProgressBarIcon';

const ENABLE_NAVIGATION = env.enableNavigation;


const ProgressBar = ({ moveTo, currentStep, lineCd }) => {
  const applicationModel = useContext(ModelContext);
  let { selectedDrivers, selectedRisks } = useContext(DriversAndVehiclesDataReportContext);
  const { disabledSteps } = useContext(WorkflowStepsContext);


  const renderBeanList = (step, stepIndex, description) => {
    const { setScrollIndex } = useContext(StepsValidationStatusContext);

    const { key } = step;

    if (key === 'drivers') {
      const beansArray = applicationModel.getValue(key);
      if (!beansArray) return null;

      const allDeleted = beansArray.every(
        (bean) => {
          if (bean.status){
            const dtDriver = selectedDrivers.find(d=>d.id === bean.id)
            return (bean.status === 'Deleted'
              || ( bean.id && bean.id.indexOf('Prefill') > 0
                && !dtDriver ));
          }else {
            return false;
          }
        }
      );

      if (allDeleted) return <p className={ls.text}>{description}</p>;

      return (
        <>
          {beansArray &&
            beansArray.map((bean, index) => {
              if (!bean.nameInfo) return null;
              if (bean.status && bean.status === 'Deleted') return null;
              const { givenName } = bean.nameInfo;
              const id = bean.id || bean._tempId;

              return (
                <div
                  key={id}
                  className={ls.mouseHover}
                  onClick={() => {
                    moveTo(stepIndex);
                    setScrollIndex(index);
                  }}
                >
                  <p className={ls.text}>{givenName}</p>
                </div>
              );
            })}
        </>
      );
    }

    if (key === 'additionalInterests') {
      const path = 'ais';
      const beansArray = applicationModel.getValue(path);
      if (!beansArray) return null;
      const allDeleted = beansArray.every(
        (bean) => bean.status && bean.status === 'Deleted'
      );
      if (allDeleted) return <p className={ls.text}>{description}</p>;

      return (
        <>
          {beansArray &&
            beansArray.map((bean, index) => {
              if (!bean) return null;
              if (bean.status && bean.status === 'Deleted') return null;
              const { interestTypeCd, interestName } = bean;
              const id = bean.id || bean._tempId;

              return (
                <div
                  key={id}
                  className={ls.mouseHover}
                  onClick={() => {
                    moveTo(stepIndex);
                    setScrollIndex(index);
                  }}
                >
                  <p className={ls.text}>
                    {interestName} {interestTypeCd}
                  </p>
                </div>
              );
            })}
        </>
      );
    }

    if (key === 'vehicles') {
      const path = `lines{lineCd:${lineCd}}.risks`;
      const beansArray = applicationModel.getValue(path);
      if (!beansArray) return null;

      const allDeleted = beansArray.every(
        (bean) => {
          if (bean.status){
            const dtRisk = selectedRisks.find(d=>d.id === bean.id)
            return (bean.status === 'Deleted'
              || ( bean.id && bean.id.indexOf('Prefill') > 0
                && !dtRisk ));
          }else {
            return false;
          }
        }
      );
      if (allDeleted) return <p className={ls.text}>{description}</p>;

      return (
        <>
          {beansArray &&
            beansArray.map((bean, index) => {
              if (!bean.vehicle) return null;
              if (bean.status && bean.status === 'Deleted') return null;
              const { modelYr, manufacturer } = bean.vehicle;
              const id = bean.id || bean._tempId;
              return (
                <div
                  key={id}
                  className={ls.mouseHover}
                  onClick={() => {
                    moveTo(stepIndex);
                    setScrollIndex(index);
                  }}
                >
                  <p className={ls.text}>
                    {modelYr} {manufacturer}
                  </p>
                </div>
              );
            })}
        </>
      );
    }

    // If the key is not one of the above use cases, display nothing.
    return null;
  };

  const Steps = () => {
    const { stepsValidationStatus } = useContext(StepsValidationStatusContext);

    if (stepsValidationStatus) {
      return stepsValidationStatus.map((step, index) => {
        let { description, key, title, valid } = step;
        const stepIndex = index;

        const issues = [];
        // Since api call is returning issues as an object contains empty key  ( we dont have parent bean ) for general issues. In that case errors related to General are not displaying.
        // below code making sure that it display errors related to particular step.

        if ( step.key === 'general' && step.beanPathIssuesMatcher===undefined) {
          Object.keys(applicationModel.dataIssues.byPath)
              .filter((k) => k === "general")
              .forEach((k) =>
                  applicationModel.dataIssues.byPath[k].forEach((issue) =>
                      issues.push(issue)
                  )
              );
        }else {
          if (step.beanPathIssuesMatcher) {
            Object.keys(applicationModel.dataIssues.byPath)
              .filter((k) => k.match(step.beanPathIssuesMatcher))
              .forEach((k) =>
                applicationModel.dataIssues.byPath[k].forEach((issue) =>
                  issues.push(issue)
                )
              );
          }
        }

        valid = valid && issues.length === 0;

        return (
          <div
            key={key}
            aria-label={`${title} step`}
            className={ENABLE_NAVIGATION ? "mouse-hover" : null}
            style={{
              opacity: disabledSteps.includes(step.key) ? 0.5: 1,
              marginTop: '10px',
              borderLeft:
                currentStep === index || valid === true
                  ? '3px solid #00abdd'
                  : '3px solid #d0d9e1',
              display: 'flex',
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  display: 'flex',
                  paddingLeft: '8px',
                }}
                onClick={() => {
                  ENABLE_NAVIGATION ? moveTo(stepIndex, true, false) : null;
                }}
              >
                <ProgressBarIcon issues valid={valid} iconKey={key} index currentStep/>
                <h3 className={ls.stepTitle} style={{ paddingLeft: '8px' }} tabIndex={index}>
                  {title}
                </h3>
              </div>
              <div className={ls.textContainer}>
                {renderBeanList(step, stepIndex, description) === null ? (
                  <p className={ls.text}>{description}</p>
                ) : (
                  renderBeanList(step, stepIndex, description)
                )}
              </div>
            </div>

            <div style={{ alignSelf: 'center', cursor: 'pointer' }}>
              {issues.length !== 0 && (
                <Popover
                  content={
                    <div>
                      {issues.map((issue) => (
                        <div key={issue}>{issue}</div>
                      ))}
                    </div>
                  }
                  title="Validation Issues"
                >
                  <Badge count={issues.length} />
                </Popover>
              )}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <Card aria-label="Progress bar">
      <Steps />
    </Card>
  );
};

export default ProgressBar;
